import { Skeleton } from "@/components/ui/skeleton";


/**
 * Skeleton that mirrors the profile page layout: header + left panel (avatar, name) + main content cards.
 * Use on mentor, mentee, and user profile pages while data is loading.
 */
export function ProfilePageSkeleton(): React.ReactElement {
  return (
    <div className="container pt-8 pb-12">
      <div className="mx-auto max-w-4xl">
        <header className="mb-8">
          <Skeleton className="h-9 w-48 rounded-md" />
          <Skeleton className="mt-2 h-4 w-72 max-w-full rounded-md" />
        </header>
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-[280px_1fr] lg:items-start">
          <aside className="min-w-0 space-y-4">
            <div className="rounded-xl border border-border bg-bg-card p-4 shadow-sm">
              <div className="flex flex-col items-center gap-3 sm:flex-row sm:items-start sm:gap-4">
                <Skeleton className="h-24 w-24 shrink-0 rounded-full" />
                <div className="min-w-0 flex-1 space-y-2 text-center sm:text-left">
                  <Skeleton className="mx-auto h-5 w-36 rounded-md sm:mx-0" />
                  <Skeleton className="mx-auto h-4 w-28 rounded-md sm:mx-0" />
                  <Skeleton className="mx-auto h-6 w-20 rounded-full sm:mx-0" />
                </div>
              </div>
            </div>
            <Skeleton className="h-20 w-full rounded-xl" />
          </aside>
          <div className="min-w-0 space-y-6">
            <div className="rounded-xl border border-border bg-bg-card shadow-sm">
              <div className="border-b border-border px-6 py-4">
                <Skeleton className="h-6 w-40 rounded-md" />
              </div>
              <div className="space-y-4 p-6">
                <Skeleton className="h-4 w-full max-w-xl rounded-md" />
                <Skeleton className="h-4 max-w-lg rounded-md" />
                <div className="grid gap-3 sm:grid-cols-2">
                  <Skeleton className="h-16 rounded-lg" />
                  <Skeleton className="h-16 rounded-lg" />
                  <Skeleton className="h-16 rounded-lg" />
                </div>
              </div>
            </div>
            <div className="rounded-xl border border-border bg-bg-card shadow-sm">
              <div className="border-b border-border px-6 py-4">
                <Skeleton className="h-6 w-44 rounded-md" />
              </div>
              <div className="grid gap-4 p-6 sm:grid-cols-2">
                <Skeleton className="h-14 rounded-lg" />
                <Skeleton className="h-14 rounded-lg" />
                <Skeleton className="h-14 rounded-lg" />
                <Skeleton className="h-14 rounded-lg" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
